export const TypesAvariasCargaSolta = {
    AVARIAS_CS: "AVARIAS_CS",
    ADD_AVARIAS_CS: "ADD_AVARIAS_CS",
    REMOVE_AVARIAS_CS: "REMOVE_AVARIAS_CS",
    AVARIA_LOCAL_CHECKED_CS: "AVARIA_LOCAL_CHECKED_CS",
    AVARIA_TIPO_CHECKED_CS: "AVARIA_TIPO_CHECKED_CS",
    AVARIA_COMPLEMENTO_CHECKED_CS: "AVARIA_COMPLEMENTO_CHECKED_CS",
    AVARIA_PROVIDENCIA_CHECKED_CS: "AVARIA_PROVIDENCIA_CHECKED_CS",
    AVARIA_PESO_CS: "AVARIA_PESO_CS",
    AVARIA_REMOVER_CHECKED_CS: "AVARIA_REMOVER_CHECKED_CS",
    RESET_CS: "RESET_CS"
}

const INITIAL = {
    $id: 0,
    TiposAvaria: [],
    LocaisAvaria: [],
    ComplementosAvaria: [],
    ProvidenciasAvaria: [],
    Avarias: [],
    avariaLocalChecked: [],
    avariaTipoChecked: [],
    avariaComplementoChecked: [],
    avariaProvidenciaChecked: [],
    avariaRemoverChecked: [],
    avariaPeso: 0
}

export default function avariasCargaSoltaReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesAvariasCargaSolta.AVARIAS_CS:
            return {
                ...state,
                $id: action.payload.$id,
                TiposAvaria: action.payload.Tipos,
                LocaisAvaria: action.payload.Locais,
                ComplementosAvaria: action.payload.Complementos,
                ProvidenciasAvaria: action.payload.Providencias
            };
        case TypesAvariasCargaSolta.ADD_AVARIAS_CS:
            return {
                ...state,
                // Avarias: [...state.Avarias, ...action.payload]
                Avarias: action.payload
            };
        case TypesAvariasCargaSolta.AVARIA_LOCAL_CHECKED_CS:
            return {
                ...state,
                avariaLocalChecked: action.payload
            };
        case TypesAvariasCargaSolta.AVARIA_TIPO_CHECKED_CS:
            return {
                ...state,
                avariaTipoChecked: action.payload
            };
        case TypesAvariasCargaSolta.AVARIA_COMPLEMENTO_CHECKED_CS:
            return {
                ...state,
                avariaComplementoChecked: action.payload
            };
        case TypesAvariasCargaSolta.AVARIA_PROVIDENCIA_CHECKED_CS:
            return {
                ...state,
                avariaProvidenciaChecked: action.payload
            }
        case TypesAvariasCargaSolta.AVARIA_PESO_CS:
            return {
                ...state,
                avariaPeso: action.payload
            }
        case TypesAvariasCargaSolta.AVARIA_REMOVER_CHECKED_CS:
            return {
                ...state,
                avariaRemoverChecked: action.payload
            };
        case TypesAvariasCargaSolta.REMOVE_AVARIAS_CS:
            return ({
                ...state,
                Avarias: [...state.Avarias.filter(function (a, index) { return !state.avariaRemoverChecked.includes(index) })]
            })
        case TypesAvariasCargaSolta.RESET_CS:
            return INITIAL;

        default:
            return state;
    }
}

export const AvariasCargaSoltaActions = {
    getAvarias,
    addAvariasCargaSolta,
    deletarAvariasCargaSolta,
    avariaLocalChecked,
    avariaTipoChecked,
    avariaComplementoChecked,
    avariaProvidenciaChecked,
    avariaPeso,
    avariaRemoverChecked,
    resetAvarias
}

function getAvarias(dadosAvarias) {
    return {
        type: TypesAvariasCargaSolta.AVARIAS_CS,
        payload: dadosAvarias
    }
}

function avariaLocalChecked(checked) {
    return {
        type: TypesAvariasCargaSolta.AVARIA_LOCAL_CHECKED_CS,
        payload: checked
    }
}

function avariaTipoChecked(checked) {
    return {
        type: TypesAvariasCargaSolta.AVARIA_TIPO_CHECKED_CS,
        payload: checked
    }
}

function avariaComplementoChecked(checked) {
    return {
        type: TypesAvariasCargaSolta.AVARIA_COMPLEMENTO_CHECKED_CS,
        payload: checked
    }
}

function avariaProvidenciaChecked(checked) {
    return {
        type: TypesAvariasCargaSolta.AVARIA_PROVIDENCIA_CHECKED_CS,
        payload: checked
    }
}

function avariaPeso(peso) {
    return {
        type: TypesAvariasCargaSolta.AVARIA_PESO_CS,
        payload: peso
    }
}

function avariaRemoverChecked(checked) {
    return {
        type: TypesAvariasCargaSolta.AVARIA_REMOVER_CHECKED_CS,
        payload: checked
    }
}

function addAvariasCargaSolta(dadosAvarias) {
    return {
        type: TypesAvariasCargaSolta.ADD_AVARIAS_CS,
        payload: dadosAvarias
    }
}

function deletarAvariasCargaSolta(avaria) {
    return {
        type: TypesAvariasCargaSolta.REMOVE_AVARIAS_CS
    }
}

function resetAvarias() {
    return { 
        type: TypesAvariasCargaSolta.RESET_CS
    }
}
